module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no numbers found":"no numbers found","available phone numbers":"available phone numbers","no area codes found":"no area codes found","area code":"area code"},"de":{"no numbers found":"keine Nummern gefunden","available phone numbers":"verfügbare Rufnummern","no area codes found":"keine Vorwahlen gefunden","area code":"Vorwahl"}}')
  delete Component.options._Ctor
}
